import { CopyLinkSectionCombinedProps } from './types';

const usePresenter = (props: CopyLinkSectionCombinedProps): CopyLinkSectionCombinedProps => {
  return props;
};

export default usePresenter;
